import styled from 'styled-components'

export const MatchIcon = styled.img`
    width:35px;
    height:35px;
    margin: 0 3%;
    @media(max-width:1920px){
        width:30px;
        height:30px;
    }
`
export const Icon = styled.img`
    width:34px;
    height:34px;
    margin-right: 20px;
    margin-left: 10px;

    @media(max-width:1920px){
        width:30px;
        height:30px;
        margin-right: 15px;
        margin-left: 20px;
    }
`;

export const SocialIcon = styled.img`
    width:35px;
    height:35px;
    margin-bottom:11px;

    @media(max-width:1920px){
        width:30px;
        height:30px;
    }

    @media(max-width: 1300px){
        margin-bottom:20px;
    }
`;